var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon has-text-grey-darker poly-cursor-pointer",on:{"click":_vm.toggle}},[(_vm.track.liked)?_c('i',{staticClass:"mdi mdi-18px mdi-heart"}):_c('i',{staticClass:"mdi mdi-18px mdi-heart-outline has-text-grey-light"})])}
var staticRenderFns = []

export { render, staticRenderFns }